<template>
  <v-card
    class="invoice-parameter-card px-0">
    <v-data-table
      class="default-table-height invoice-parameter-table"
      mobile-breakpoint="0"
      :footer-props="{
        'items-per-page-text': 'Linhas por página',
        'first-icon': 'mdi-chevron-up',
        'page-text': '',
        'items-per-page-options': [10, 25, 50, 100],
      }"
      :items="configs"
      :headers="headers">
      <template
        v-slot:[`header.status`]>
        <Header>Status</Header>
      </template>
      <template
        v-slot:[`header.type`]>
        <Header>Tipo de Nível</Header>
      </template>
      <template
        v-slot:[`header.entity`]>
        <Header>Opção do Nível</Header>
      </template>
      <template
        v-slot:[`header.rule`]>
        <Header>Regra</Header>
      </template>
      <template
        v-slot:[`header.description`]>
        <Header>Descrição</Header>
      </template>
      <template
        v-slot:[`header.value`]>
        <Header>Valor</Header>
      </template>
      <template
        v-slot:[`header.action`]>
        <Header>Ações</Header>
      </template>

      <template
        v-slot:[`item.status`]="{ item }">
        <TableBody>
          {{ item.active ? 'Ativo' : 'Inativo' }}
        </TableBody>
      </template>
      <template
        v-slot:[`item.type`]="{ item }">
        <TableBody>
          {{ getEntityLevelName(item.entityLevel) }}
        </TableBody>
      </template>
      <template
        v-slot:[`item.entity`]="{ item }">
        <TableBody>
          {{ item.entityLevelName }}
        </TableBody>
      </template>
      <template
        v-slot:[`item.rule`]="{ item }">
        <TableBody>
          {{ item.name }}
        </TableBody>
      </template>
      <template
        v-slot:[`item.description`]="{ item }">
        <TableBody>
          {{ item.description }}
        </TableBody>
      </template>
      <template
        v-slot:[`item.value`]="{ item }">
        <TableBody
          v-if="!isList(item.valueType)">
          {{ convertText(getConfigValue(item.value, item.valueType)) }}
        </TableBody>
        <div
          class="d-flex flex-row align-center"
          v-if="isList(item.valueType)">
          <v-chip>
            <TableBody textSm>
              {{ convertText(getConfigValue(item.value[0], item.valueType)) }}
            </TableBody>
          </v-chip>
          <v-tooltip
            bottom>
            <template v-slot:activator="{ on: onTab, attrs: attrsTab }">
              <span
                v-on="onTab"
                v-bind="attrsTab"
                textSm
                class="ml-2 foreground--text text-caption">
                {{
                  formatter.getPluralText(
                    "outra",
                    item.value
                  )
                }}
              </span>
            </template>
            <span>
              {{ getOptionsDescription(item.value, item.valueType) }}
            </span>
          </v-tooltip>
        </div>
      </template>
      <template
        v-slot:[`item.action`]="{ item, index }">
        <div class="fill-height d-flex align-center justify-center">
          <v-menu transition="slide-y-transition" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                icon
                class="elevation-0">
                <v-icon
                  color="muted-accent"
                  size="16">
                  fas fa-ellipsis-v
                </v-icon>
              </v-btn>
            </template>
            <TodoListActions :actions="actions(item, index)" />
          </v-menu>
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import AuthorityManagementMixin from '@/shared/mixins/authorityManagement/authorityManagementMixin';
import InvoiceParametersMixin from '@/shared/mixins/invoiceParameters/InvoiceParametersMixin';
import InvoiceParameterHeader from './components/InvoiceParameterHeader.vue';
import InvoiceParameterTableBody from './components/InvoiceParameterTableBody.vue';
import TodoListActions from '../TodoList/TodoListActions.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
  name: "InvoiceParameterTable",
  components: {
    TodoListActions,
    Header: InvoiceParameterHeader,
    TableBody: InvoiceParameterTableBody,
  },
  mixins: [
    AuthorityManagementMixin,
    InvoiceParametersMixin,
  ],
  methods: {
    ...mapActions({
      startUpdateConfig: 'invoice-parameter/startUpdateConfig',
      unlinkFormConfig: 'invoice-parameter/unlinkFormConfig',
      startCopyConfig: 'invoice-parameter/startCopyConfig',
    }),
    actions(item) {
      const actions = [
        {
          label: 'Editar',
          icon: 'fas fa-pen',
          condition: this.hasPermission('sdi_faturas_conferencia_parametros_editar'),
          handler: () => this.editConfig(item),
        },
        {
          label: 'Copiar parâmetro',
          icon: 'far fa-copy',
          condition: this.hasPermission('sdi_faturas_conferencia_parametros_copiar'),
          handler: () => this.copyConfig(item),
        },
        {
          label: 'Desvincular',
          icon: 'icons/unlink-alt.svg',
          isSvg: true,
          condition: this.hasPermission('sdi_faturas_conferencia_parametros_desvincular'),
          handler: () => this.unlinkFormConfig(item),
        },
      ];

      actions.sort((a, b) => a.label.localeCompare(b.label));

      return actions;
    },
    editConfig(formConfig) {
      this.startUpdateConfig(formConfig);
      this.redirectRouter('InvoiceParameterForm', { isRHProtegido: this.isRHProtegido });
    },
    copyConfig(formConfig) {
      this.startCopyConfig(formConfig);
      this.redirectRouter('InvoiceParameterForm', { isRHProtegido: this.isRHProtegido });
    }
  },
  computed: {
    ...mapGetters({
      isRHProtegido: 'user-info/isRHProtegido',
      configs: 'invoice-parameter/configs',
    }),
    headers() {
      return [
        { value: 'status', sortable: false, class: 'col-status', cellClass: 'col-status' },
        { value: 'type', sortable: false,   class: 'col-type', cellClass: 'col-type' },
        { value: 'entity', sortable: false, class: 'col-entity', cellClass: 'col-entity' },
        { value: 'rule', sortable: false,   class: 'col-rule', cellClass: 'col-rule' },
        { value: 'description', sortable: false, class: 'col-description', cellClass: 'col-description' },
        { value: 'value', sortable: false,  class: 'col-value', cellClass: 'col-value' },
        { value: 'action', sortable: false, align: 'center', class: 'col-action text-center', cellClass: 'col-action text-center' },
      ];
    },
  },
}
</script>
<style lang="scss">
@import "@/shared/styles/invoiceParameters/table.scss";
</style>